import * as React from 'react';

const RecentActivityIcon: React.FC = () => (
	<svg
		width='18'
		height='18'
		viewBox='0 0 18 18'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'>
		<g
			id='Synchronize-Refresh-Arrow--Streamline-Ultimate'
			clip-path='url(#clip0_120_16210)'>
			<path
				id='Vector'
				d='M3.401 10.6966V9.16756C3.40134 7.5744 3.97634 6.03484 5.02043 4.83151C6.06452 3.62818 7.50763 2.84184 9.08482 2.61687C10.662 2.3919 12.2674 2.74339 13.6063 3.60681C14.9452 4.47023 15.9277 5.78764 16.3735 7.31716C16.8192 8.84668 16.6983 10.4857 16.0329 11.9332C15.3675 13.3807 14.2023 14.5397 12.7512 15.1973C11.3001 15.8549 9.66048 15.9669 8.13339 15.513C7.34283 15.2779 6.60989 14.8994 5.968 14.4024'
				stroke='#0973BA'
				stroke-width='1.0625'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				id='Vector_2'
				d='M1.36499 8.65869L3.40101 10.6947L5.43702 8.65869'
				stroke='#0973BA'
				stroke-width='1.0625'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				id='Vector_3'
				d='M10.0625 5.28125V9.53125H13.25'
				stroke='#0973BA'
				stroke-width='1.0625'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</g>
		<defs>
			<clipPath id='clip0_120_16210'>
				<rect
					width='17'
					height='17'
					fill='white'
					transform='translate(0.5 0.5)'
				/>
			</clipPath>
		</defs>
	</svg>
);

export default RecentActivityIcon;
